import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "item"
};
const _hoisted_2 = {
  class: "body"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = {
  class: "body"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "body"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "body"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = {
  class: "body"
};
const _hoisted_11 = {
  key: 0,
  class: "item"
};
const _hoisted_12 = {
  class: "body"
};
const _hoisted_13 = {
  key: 1,
  class: "item"
};
const _hoisted_14 = {
  class: "body"
};
const _hoisted_15 = {
  key: 2,
  class: "item"
};
const _hoisted_16 = {
  class: "body"
};
const _hoisted_17 = {
  key: 3,
  class: "item"
};
const _hoisted_18 = {
  class: "body"
};
const _hoisted_19 = {
  key: 4,
  class: "item"
};
const _hoisted_20 = {
  class: "body"
};
const _hoisted_21 = {
  key: 5,
  class: "item"
};
const _hoisted_22 = {
  class: "body"
};
const _hoisted_23 = {
  key: 6,
  class: "item"
};
const _hoisted_24 = {
  class: "body"
};
const _hoisted_25 = {
  key: 7,
  class: "item"
};
const _hoisted_26 = {
  class: "body"
};
const _hoisted_27 = {
  key: 8,
  class: "item"
};
const _hoisted_28 = {
  class: "body"
};
import { ImageApi } from '@/api/ai/image';
import { AiPlatformEnum, Dall3StyleList, StableDiffusionClipGuidancePresets, StableDiffusionSamplers, StableDiffusionStylePresets } from '@/views/aip/utils/constants';
import { formatTime } from '@/utils/formatTime';
import { ref, toRefs, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageDetail',
  props: {
    show: {
      type: Boolean,
      require: true,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  emits: ['handleDrawerClose'],
  setup(__props, {
    emit: __emit
  }) {
    const showDrawer = ref(false); // 是否显示
    const detail = ref({}); // 图片详细信息
    const props = __props;
    /** 关闭抽屉  */
    const handleDrawerClose = async () => {
      emits('handleDrawerClose');
    };
    /** 监听 drawer 是否打开 */
    const {
      show
    } = toRefs(props);
    watch(show, async (newValue, oldValue) => {
      showDrawer.value = newValue;
    });
    /**  获取图片详情  */
    const getImageDetail = async id => {
      detail.value = await ImageApi.getImageMy(id);
    };
    /** 监听 id 变化，加载最新图片详情 */
    const {
      id
    } = toRefs(props);
    watch(id, async (newVal, oldVal) => {
      if (newVal) {
        await getImageDetail(newVal);
      }
    });
    const emits = __emit;
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createBlock(_component_el_drawer, {
        modelValue: showDrawer.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDrawer.value = $event),
        title: "图片详细",
        onClose: handleDrawerClose,
        "custom-class": "drawer-class"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
          class: "image",
          src: detail.value?.picUrl,
          "preview-src-list": [detail.value.picUrl],
          "preview-teleported": ""
        }, null, 8, ["src", "preview-src-list"])])]), _createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "tip"
        }, "时间", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, "提交时间：" + _toDisplayString(_unref(formatTime)(detail.value.createTime, 'yyyy-MM-dd HH:mm:ss')), 1), _createElementVNode("div", null, "生成时间：" + _toDisplayString(_unref(formatTime)(detail.value.finishTime, 'yyyy-MM-dd HH:mm:ss')), 1)])]), _createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tip"
        }, "模型", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(detail.value.model) + "(" + _toDisplayString(detail.value.height) + "x" + _toDisplayString(detail.value.width) + ") ", 1)]), _createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "tip"
        }, "提示词", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(detail.value.prompt), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "tip"
        }, "图片地址", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(detail.value.picUrl), 1)]), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.sampler ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "tip"
        }, "采样方法", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(StableDiffusionSamplers).find(item => item.key === detail.value?.options?.sampler)?.name), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.clipGuidancePreset ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "tip"
        }, "CLIP", -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(StableDiffusionClipGuidancePresets).find(item => item.key === detail.value?.options?.clipGuidancePreset)?.name), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.stylePreset ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "tip"
        }, "风格", -1)), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(StableDiffusionStylePresets).find(item => item.key === detail.value?.options?.stylePreset)?.name), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.steps ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "tip"
        }, "迭代步数", -1)), _createElementVNode("div", _hoisted_18, _toDisplayString(detail.value?.options?.steps), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.scale ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "tip"
        }, "引导系数", -1)), _createElementVNode("div", _hoisted_20, _toDisplayString(detail.value?.options?.scale), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).STABLE_DIFFUSION && detail.value?.options?.seed ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "tip"
        }, "随机因子", -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(detail.value?.options?.seed), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).OPENAI && detail.value?.options?.style ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "tip"
        }, "风格选择", -1)), _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(Dall3StyleList).find(item => item.key === detail.value?.options?.style)?.name), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).MIDJOURNEY && detail.value?.options?.version ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "tip"
        }, "模型版本", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(detail.value?.options?.version), 1)])) : _createCommentVNode("", true), detail.value.platform === _unref(AiPlatformEnum).MIDJOURNEY && detail.value?.options?.referImageUrl ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "tip"
        }, "参考图", -1)), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_image, {
          src: detail.value.options.referImageUrl
        }, null, 8, ["src"])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});